import React, { useState } from 'react';
import { db } from '../../firebaseConfig';
import { collection, getDocs, setDoc, doc } from 'firebase/firestore';
import '../../styles/AdminNotification.css';

const AdminBroadcastNotification = () => {
  const [notificationTitle, setNotificationTitle] = useState('');
  const [notificationContent, setNotificationContent] = useState('');

  const handleBroadcastNotification = async () => {
    if (notificationTitle.trim() === '' || notificationContent.trim() === '') return;

    const notificationId = `${new Date().getTime()}`; // 一意のIDを生成
    const notificationData = {
      title: notificationTitle,
      content: notificationContent,
      createdAt: new Date(),
      read: false,
    };

    try {
      // `general_notifications` に通知を保存
      await setDoc(doc(db, `general_notifications`, notificationId), notificationData);

      // `members/{id}/notifications` に通知を保存
      const membersQuerySnapshot = await getDocs(collection(db, 'members'));
      const memberNotificationsPromises = membersQuerySnapshot.docs.map(async (memberDoc) => {
        const userNotificationRef = doc(db, `members/${memberDoc.id}/notifications`, notificationId);
        await setDoc(userNotificationRef, {
          ...notificationData,
          judge: 'gen', // `judge` フィールドを追加
        });
      });

      await Promise.all(memberNotificationsPromises);

      setNotificationTitle('');
      setNotificationContent('');
      alert('全員に通知を送信しました。');
    } catch (error) {
      console.error('Error broadcasting notification:', error);
      alert('通知の送信に失敗しました。');
    }
  };

  return (
    <div className="admin-notification-container">
      <h2>全員への通知送信</h2>
      <div className="notification-form">
        <input
          type="text"
          value={notificationTitle}
          onChange={(e) => setNotificationTitle(e.target.value)}
          placeholder="通知のタイトルを入力"
        />
        <textarea
          value={notificationContent}
          onChange={(e) => setNotificationContent(e.target.value)}
          placeholder="通知の内容を入力"
          rows="4"
        />
        <button onClick={handleBroadcastNotification}>送信</button>
      </div>
    </div>
  );
};

export default AdminBroadcastNotification;
